import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { List, Icon } from "@mui/material";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { MenuNavLink, MenuListItemIcon, MenuListItem, MenuListItemText } from "./MenuStyles";

const Menu = ({ miniActive, userInfo }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const activeRoute = routeName => {
    return location.pathname.indexOf(routeName) > -1 ? true : false;
  };

  const { menuItems } = userInfo;

  return (
    <>
      {menuItems && (
        <nav>
          <List>
            {menuItems.map((item, key) => {
              const menu = { text: item.caption, name: item.description, icon: item.menuIcon, path: item.menuRoute };

              return (
                <MenuListItem key={key} id={"sidebar_menu_" + t(menu.text).toLowerCase()}>
                  <MenuNavLink to={menu.path} active={activeRoute(menu.path)}>
                    <MenuListItemIcon>
                      <Icon>{menu.icon}</Icon>
                    </MenuListItemIcon>
                    <MenuListItemText visible={!miniActive} primary={t(menu.text)} disableTypography={true} />
                  </MenuNavLink>
                </MenuListItem>
              );
            })}
          </List>
        </nav>
      )}
    </>
  );
};

Menu.propTypes = {
  userRole: PropTypes.string,
  miniActive: PropTypes.bool.isRequired,
  userInfo: PropTypes.object
};

function mapStateToProps(state) {
  let userRole;
  if (state.oidc.user && state.oidc.user.profile && state.oidc.user.profile.role)
    userRole = state.oidc.user.profile.role;

  return {
    userRole,
    userInfo: state.userInfo
  };
}

export default connect(mapStateToProps)(Menu);
